import React, {useEffect, useRef } from "react"
import Play from '../fa/Play';
import Pause from '../fa/Pause';

const Controller = ({mode, togglePlayPause, el, circleRef}) => {
    const ctrlRef = useRef(null); 
    useEffect(()=>{
        if (el === "video") {
            if (mode === "play" && ctrlRef !== null) {
                ctrlRef.current.classList.add("transparent")
            } else {
                ctrlRef.current.classList.remove("transparent")
            }
        }
        },[mode, el])
    return (
        <div className="controls" ref={ctrlRef}>
            <button title={mode === null ? "play" : mode === "pause" ? "play" : "pause"} onClick={togglePlayPause}>
                {mode === null ? <Play /> : mode === "pause" ? <Play /> : <Pause /> }
            </button>
            <svg className="prog" viewBox="0 0 36 36">
            <path
                className="path"
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
                fill="none"
                stroke="#C2C2C2"
                opacity="1"
                strokeWidth="0"
              />
            <path
              className="progress"
              ref={circleRef}
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none"
              stroke="#2258CF"
              strokeWidth="1"
            />
          </svg>
            
        </div>
    )
}

export default Controller;